import { Alert, AlertTitle, Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ClosedMemberDuplicationCheckDTO } from '@/api/DTO/member-management/memberDuplication';

/**
 * Shown on the register form when a service-closed member was picked in the
 * duplication check: the link is sent with the register request.
 */
export default function PendingClosedMemberAlert({
	closedMember,
}: {
	closedMember: ClosedMemberDuplicationCheckDTO;
}) {
	const { t } = useTranslation();
	return (
		<Alert severity='info' sx={{ marginBottom: '12px' }}>
			<AlertTitle>{t('memberDuplication.pendingLinkTitle')}</AlertTitle>
			<Trans
				i18nKey='memberDuplication.previousMemberSelected'
				values={{
					fileNo: closedMember.fileNo,
					name: [closedMember.nameEn, closedMember.nameZh]
						.filter(Boolean)
						.join(' '),
				}}
				components={{
					anchor: (
						<Link
							href={`/member-management/member-list/detail/${closedMember.id}`}
							target='_blank'
							rel='noopener noreferrer'
							color='#1BBED7'
						/>
					),
				}}
			/>
		</Alert>
	);
}
